// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"359":"05eb4f6b","438":"c81a755b","767":"2c835ffb","785":"2a47f9b6"}[chunkId] + ".chunk.js";
};